import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const postVANData = async ({ data }) => {
  try {
    const response = await safetyDefaultAPI.post('van', data);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default postVANData;
